import React, { useState } from "react";
import { Route, Routes, useParams } from "react-router-dom";

import PatternsContainer from "../../../containers/administration/patterns/PatternsContainer";
import LinksContainer from "../../GeneralComponents/LinksContainer/LinksContainer";
import ConfirmationModal from "../../confirmationModal/confirmationModal";

import { referenceData } from "./referenceData";

function ManagementTemplates() {
  const [showModal, setShowModal] = useState(false);
  const route = useParams();

  return (
    <>
      {route["*"] ? (
        <Routes>
          {referenceData.map((item) => (
            <Route
              key={item.id}
              path={item.url}
              element={
                <PatternsContainer
                  title={item.titlePage || item.title}
                  url={item.url}
                  id={item.id}
                  setShowModal={setShowModal}
                />
              }
            />
          ))}
        </Routes>
      ) : (
        <LinksContainer
          title="Ведение шаблонов документов"
          links={referenceData}
        />
      )}
      {showModal && (
        <ConfirmationModal
          isOpen={showModal}
          title="Изменения успешно сохранены!"
          onClose={() => {
            setShowModal(false);
          }}
        />
      )}
    </>
  );
}

export default ManagementTemplates;
